import {createSlice} from "@reduxjs/toolkit";
import { getCountGraph, getIncomeGraph } from './action';

const initialState = {
  state: {
    incomeThisMonth: [],
    incomeLastMonth: [],
    customerCountThisMonth: [],
    customerCountLastMonth: [],
    bookingCountThisMonth: [],
    bookingCountLastMonth: []
  },
  loading: true,
  error: ''
} as BaseState<HomeGraphState>

const slice = createSlice({
  name: 'homeGraphSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //Income Graph
    builder.addCase(getIncomeGraph.pending, (state) => ({
        ...state,
        loading: true
      })
    )
    builder.addCase(getIncomeGraph.fulfilled, (state, action) => {
      const newState = {
        state: {},
        loading: null,
        error: null
      }
      if (action.payload.type === 'CURRENT_MONTH') {
        newState.state = {
          ...state.state,
          incomeThisMonth: [...action.payload.data]
        }
      } else if (action.payload.type === 'LAST_MONTH') {
        newState.state = {
          ...state.state,
          incomeLastMonth: [...action.payload.data]
        }
      }
      return newState
    })
    builder.addCase(getIncomeGraph.rejected, (state, action) => {
      const newState = {
        state: {},
        loading: null,
        error: null
      }
      if (action.type === 'CURRENT_MONTH') {
        newState.state = {
          ...state.state,
          incomeThisMonth: []
        }
      } else if (action.type === 'LAST_MONTH') {
        newState.state = {
          ...state.state,
          incomeLastMonth: []
        }
      }
      return newState
    })

    //Count Graph
    builder.addCase(getCountGraph.pending, (state) => ({
        ...state,
        loading: true
      })
    )
    builder.addCase(getCountGraph.fulfilled, (state, action) => {
      const newState = {
        state: {},
        loading: null,
        error: null
      }
      if (action.payload.type === 'CUSTOMER_THIS_MONTH') {
        newState.state = {
          ...state.state,
          customerCountThisMonth: [...action.payload.data]
        }
      } else if (action.payload.type === 'CUSTOMER_LAST_MONTH') {
        newState.state = {
          ...state.state,
          customerCountLastMonth: [...action.payload.data]
        }
      } else if (action.payload.type === 'BOOKING_THIS_MONTH') {
        newState.state = {
          ...state.state,
          bookingCountThisMonth: [...action.payload.data]
        }
      } else if (action.payload.type === 'BOOKING_LAST_MONTH') {
        newState.state = {
          ...state.state,
          bookingCountLastMonth: [...action.payload.data]
        }
      }
      return newState
    })
    builder.addCase(getCountGraph.rejected, (state, action) => {
      const newState = {
        state: {},
        loading: null,
        error: null
      }
      if (action.type === 'CUSTOMER_THIS_MONTH') {
        newState.state = {
          ...state.state,
          customerCountThisMonth: []
        }
      } else if (action.type === 'CUSTOMER_LAST_MONTH') {
        newState.state = {
          ...state.state,
          customerCountLastMonth: []
        }
      } else if (action.type === 'BOOKING_THIS_MONTH') {
        newState.state = {
          ...state.state,
          bookingCountThisMonth: []
        }
      }
      else if (action.type === 'BOOKING_LAST_MONTH') {
        newState.state = {
          ...state.state,
          bookingCountLastMonth: []
        }
      }
      return newState
    })
  }
})

export default slice
